import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Alert, Button, Col, DropdownButton, DropdownItem as MenuItem, Form, FormCheck as Checkbox, FormControl, FormGroup, FormLabel as ControlLabel, Modal, Row} from 'react-bootstrap'

import {LinkContainer} from 'react-router-bootstrap'
import * as Acl from "../utils/acl"


const defaultChangePassword = {
	email: "",
	password: "",
	password2: "",
	errorSeen: false,
	submitted: false
};

const isValidPassword = (password) => {
	return password && password.length >= 5 && password.search(/[!#$%&? "'_\-@^*]/) >= 0
};

class Header extends Component {

	constructor(props) {
		super(props);

		this.state = {
			search: props && props.params && props.params.search ? props.params.search : '',
			isLoginModalOpen: false,
			forgottenPassword: false,
			login: {
				email: "",
				password: "",
				rememberMe: 1,
				errorSeen: false
			},
			isChangePasswordModalOpen: false,
			changePassword: Object.assign({}, defaultChangePassword)
		};

		this.handleLoginInputChange = this.handleLoginInputChange.bind(this)
		this.handleLoginSubmit = this.handleLoginSubmit.bind(this)
		this.handleForgottenPasswordSubmit = this.handleForgottenPasswordSubmit.bind(this)
		this.handleSearchChange = this.handleSearchChange.bind(this)
		this.handleSearch = this.handleSearch.bind(this)
		this.handleLoginModalDismissClick = this.handleLoginModalDismissClick.bind(this)
		this.handleLoginModalOpenClick = this.handleLoginModalOpenClick.bind(this)

		this.handleChangePasswordInputChange = this.handleChangePasswordInputChange.bind(this)
		this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this)
		this.handleChangePasswordModalDismissClick = this.handleChangePasswordModalDismissClick.bind(this)
		this.handleChangePasswordModalOpenClick = this.handleChangePasswordModalOpenClick.bind(this)
	}

	componentDidUpdate(prevProps) {
		const {session, token} = this.props;
		const {isLoginModalOpen, isChangePasswordModalOpen} = this.state;

		if (isLoginModalOpen && Acl.isLoggedIn(session)) {
			// successful login, close modal
			this.setState({isLoginModalOpen: false});
			return
		}

		if (!isChangePasswordModalOpen && !Acl.isLoggedIn(session) && token) {
			this.setState({isChangePasswordModalOpen: true});
			return
		}
	}

	handleSearchChange(e) {
		this.setState({search: e.target.value})
	}

	handleSearch() {
		if (this.state.search && this.state.search.length > 1) {
			this.props.history('/vyhledat/?search=' + this.state.search)
		}
	}

	handleLoginInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.id;

		const {login} = this.state;
		if (target.type === 'checkbox' && !target.checked) {
			login[name] = 0
		} else {
			login[name] = target.type === 'checkbox' ? 1 : value
		}
		this.setState({login: login})
	}

	handleForgottenPasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onForgottenPassword(login.email).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.handleLoginModalDismissClick()
			}
		})
	}

	handleLoginSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onLogin(login.email, login.password, login.rememberMe)
	}

	handleLoginModalDismissClick = e => {
		if (e) {
			e.preventDefault()
		}
		const {login} = this.state;
		login.errorSeen = true;
		this.setState({login: login, isLoginModalOpen: false, forgottenPassword: false})
	};

	handleLoginModalOpenClick = e => {
		this.setState({isLoginModalOpen: true})
	};

	getPasswordValidationState() {
		const p = this.state.changePassword.password;
		if (!p && !this.state.changePassword.submitted) {
			return null
		}
		if (!isValidPassword(p)) {
			if (!this.state.changePassword.submitted) return 'warning';
			return 'error'
		}
		return 'success'
	}

	getPassword2ValidationState() {
		const p = this.state.changePassword.password;
		const p2 = this.state.changePassword.password2;
		if (!this.state.changePassword.submitted) {
			return null
		}
		if (p && p === p2) return 'success';
		return 'error'
	}

	handleChangePasswordInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.name;

		const {changePassword} = this.state;
		changePassword[name] = value;
		this.setState({changePassword: changePassword})
	}

	handleChangePasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {changePassword} = this.state;
		changePassword.submitted = true;
		let valid = true;
		if (changePassword.password !== changePassword.password2) {
			valid = false
		} else if (!isValidPassword(changePassword.password)) {
			valid = false
		}

		changePassword.errorSeen = false;
		this.setState({changePassword: changePassword});
		if (!valid) {
			return
		}

		this.props.onChangePassword(changePassword.email, changePassword.password, this.props.token).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.setState({changePassword: Object.assign({}, defaultChangePassword)});
				this.handleChangePasswordModalDismissClick();
				if (this.props.token) {
					this.props.history('/')
				}
			}
		})
	}

	handleChangePasswordModalDismissClick = e => {
		if (e) {
			e.preventDefault()
		}
		const {changePassword} = this.state;

		this.setState({changePassword: changePassword, isChangePasswordModalOpen: false}, () => {
			if (this.props.token) {
				this.props.history('/')
			}
		})
	};

	handleChangePasswordModalOpenClick = e => {
		this.setState({isChangePasswordModalOpen: true})
	};

	renderAlert(error) {
		return <Alert variant="danger" onDismiss={this.handleAlertDismiss}>
			<h4>Chyba</h4>
			<p>{error}</p>
		</Alert>
	}

	renderUser() {
		const {session} = this.props;
		if (session.user && session.user.userId) {
			const fullName = session.user.firstName + ' ' + session.user.lastName;
			return <div>
				<DropdownButton title={<span><span className="fa fa-user"/> {fullName}</span>} id="bg-nested-dropdown" variant="link">
					<LinkContainer to={{pathname: "/users/" + session.user.personalId}}>
						<MenuItem eventKey="1">Profil</MenuItem>
					</LinkContainer>
					<MenuItem eventKey="2" onClick={this.handleChangePasswordModalOpenClick}>Změnit heslo</MenuItem>
					<MenuItem eventKey="3" divider/>
					<MenuItem eventKey="4" onClick={this.props.onLogout}>Odhlásit</MenuItem>
				</DropdownButton>
			</div>
		} else {
			return <div>
				<Button variant="link" onClick={this.handleLoginModalOpenClick}>Přihlásit se</Button>
			</div>
		}
	}

	renderLoginModal() {
		const {isLoginModalOpen, login, forgottenPassword} = this.state;
		const {session} = this.props;

		if (!isLoginModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleLoginModalDismissClick} show={true}>
				<Form horizontal onSubmit={forgottenPassword ? this.handleForgottenPasswordSubmit : this.handleLoginSubmit}>
					<Modal.Header>
						<Modal.Title>{forgottenPassword ? 'Obnova zapomenutého hesla' : 'Přihlášení'}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						{session.error && !login.errorSeen && this.renderAlert(session.error)}
						{forgottenPassword && <p>Na emailovou adresu vašeho účtu vám budou zaslány instrukce pro obnovu hesla.</p>}
						<FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={login.email} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>

						{!forgottenPassword && <FormGroup controlId="password">
							<Col componentClass={ControlLabel} sm={3}>
								Heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={login.password} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>}

						{!forgottenPassword && <FormGroup>
							<Col smOffset={3} sm={7}>
								<Checkbox id="rememberMe" name="rememberMe" checked={login.rememberMe} onChange={this.handleLoginInputChange}>Zapamatuj si mě</Checkbox>
							</Col>
						</FormGroup>}
					</Modal.Body>

					<Modal.Footer>
						{!forgottenPassword && <Row>
							<Col sm={6} className="text-left">
								<Button variant="link" onClick={() => {
									this.setState({forgottenPassword: true})
								}}>Zapomenuté heslo</Button>
							</Col>
							<Col sm={6}>
								<Button onClick={this.handleLoginModalDismissClick}>Storno</Button>
								<Button type="submit" onClick={this.handleLoginSubmit} variant="success"><span className="fa fa-lock"/> Přihlásit <span className="fa fa-chevron-right"/></Button>
							</Col>
						</Row>}
						{forgottenPassword && <Row>
							<Col sm={6} className="text-left">
							</Col>
							<Col sm={6}>
								<Button onClick={() => {
									this.setState({forgottenPassword: false})
								}}>Storno</Button>
								<Button type="submit" onClick={this.handleForgottenPasswordSubmit} variant="success"><span className="fa fa-envelope"/> Zaslat instrukce</Button>
							</Col>
						</Row>}
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}

	renderChangePasswordModal() {
		const {isChangePasswordModalOpen, changePassword} = this.state;
		const {session, token} = this.props;

		if (!isChangePasswordModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleChangePasswordModalDismissClick} show={true}>
				<Form horizontal onSubmit={this.handleChangePasswordSubmit}>
					<Modal.Header>
						<Modal.Title>{token ? "Vytvoření nebo obnova hesla" : "Změna hesla"}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<p>Heslo musí být alespoň 5 znaků dlouhé a obsahovat speciální znak (!#$%&?_-@^*).</p>
						{session.error && !changePassword.errorSeen && this.renderAlert(session.error)}
						{!Acl.isLoggedIn(session) && <FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={changePassword.email} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>}

						<FormGroup controlId="password" validationState={this.getPasswordValidationState()}>
							<Col componentClass={ControlLabel} sm={3}>
								Nové heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={changePassword.password} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="password2" validationState={this.getPassword2ValidationState()}>
							<Col componentClass={ControlLabel} sm={3}>
								Kontrola hesla
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password2" value={changePassword.password2} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>
					</Modal.Body>

					<Modal.Footer>
						<Row>
							<Col sm={12}>
								<Button onClick={this.handleChangePasswordModalDismissClick}>Storno</Button>
								<Button type="submit" onClick={this.handleChangePasswordSubmit} variant="success"><span className="fa fa-ok"/> Změnit heslo</Button>
							</Col>
						</Row>
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}

	render() {
		const {headerContent, session} = this.props;

		return (
			<header id="header">
				{/*<IndexLinkContainer to="/">*/}
				{/*	<Button variant="link" className="logo">*/}
				{/*		<img src={logo} alt="Fakturito" height={80} style={{'verticalAlign': 'top'}}/>*/}
				{/*		<h1>Fakturito <span>Codito</span></h1>*/}
				{/*	</Button>*/}
				{/*</IndexLinkContainer>*/}
				{headerContent}
				{Acl.isLoggedIn(session) ? <div id="caption" className="pull-right text-right">
					{this.renderUser()}
					<div id="search" onSubmit={this.handleSearch}>
						<FormGroup controlId="search-query">
							{/*<InputGroup>*/}
							{/*	<FormControl*/}
							{/*		type="text"*/}
							{/*		value={this.state.search}*/}
							{/*		maxLength="50"*/}
							{/*		onChange={this.handleSearchChange}*/}
							{/*		onKeyPress={(e) => {*/}
							{/*			if (e.key === 'Enter') {*/}
							{/*				this.handleSearch()*/}
							{/*			}*/}
							{/*		}}*/}
							{/*	/>*/}
							{/*	<InputGroup.Addon onClick={this.handleSearch}>*/}
							{/*		<span className="fa fa-search"/>*/}
							{/*	</InputGroup.Addon>*/}
							{/*</InputGroup>*/}
						</FormGroup>
					</div>
				</div> : null}
				{this.renderLoginModal()}
				{this.renderChangePasswordModal()}
				{this.props.children}
			</header>
		)
	}
}

Header.propTypes = {
	onLogin: PropTypes.func.isRequired,
	onLogout: PropTypes.func.isRequired,
	onChangePassword: PropTypes.func.isRequired,
	onForgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	headerContent: PropTypes.node,
};

export default Header
